import React from 'react';
import PropTypes from 'prop-types';
import styles from './CartProduct.m.sass';

import Pricing from '../pricing/Pricing';

export default function CartProduct({name, price}) {
  return (
    <div className={styles.cartProduct}>
      <div className={styles.cartProduct_desc}>
        <div className={styles.cartProduct_name}>{name}</div>
      </div>
      <div className={styles.cartProduct__price}>
        <Pricing
          value={price}
          small
        />
      </div>
    </div>
  );
}

CartProduct.getItemTitle = item => {
  if (item.specialService && item.specialService.title) {
    return item.specialService.title;
  }

  if (item.variant.name && item.variant.product.name !== item.variant.name) {
    return `${item.variant.product.name} - ${item.variant.name}`;
  }

  return item.variant.product.name;
};



// WEBPACK FOOTER //
// ./components/cartProduct/CartProduct.js